import { performanceApi as api } from "./apiClient.tsx";
import { handleApiError } from "./errorHandler.tsx";

export const getCustomSystem = async (): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/systems");
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomVoltages = async (): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/voltages");
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomTechnology = async (voltage_id: string): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/technologies", {
      params: { voltage_id },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomRefrigerant = async (technology_id: string): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/refrigerants", {
      params: { technology_id },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomHeatExchanger = async (
  system_id: string,
  refrigerant_id: string,
  capacity: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/heat-exchangers", {
      params: {
        system_id,
        refrigerant_id,
        capacity_id: capacity,
        custom: true,
      },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomEfficiency = async (
  capacity: string,
  system_id: string,
  heat_exchanger_id: string
): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/efficiencies", {
      params: {
        capacity,
        system_id,
        heat_exchanger_id,
      },
    });
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};

export const getCustomLocations = async (): Promise<any> => {
  try {
    const { data } = await api.get("/projects/custom-forms/locations");
    return data;
  } catch (error: any) {
    throw handleApiError(error, {
      401: "Unauthorized request",
    });
  }
};
